export const SET_USER_DATA = 'SET_USER_DATA'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const SET_USER_ID = 'SET_USER_ID'
